module.exports = __webpack_public_path__ + "img/ehm.ee5de7ca.png";